// Review – load more
(function ( conf ) {
    var reviews = document.querySelector( '.reviews' ),
        moreBtn = document.querySelector( '.reviews__load-more' ),
        agreeAll = document.getElementById( 'agree-all' );

    if ( ! reviews ) {
        return;
    }

    var colc = new Colcade( reviews, {
        columns: '.grid-col',
        items: '.grid-item'
    });

    moreBtn.addEventListener( 'click', function ( e ) {
        var offset = parseInt( this.dataset.offset, 10 );
        e.preventDefault();
        loadMore( offset );
        this.dataset.offset = offset + 20;
    });

    function loadMore ( offset ) {
        var request = new XMLHttpRequest();
        request.addEventListener( 'load', function () {
            var response = JSON.parse( request.response );
            if ( ! response.success ) {
                moreBtn.remove();
            }
            var dom = new DOMParser().parseFromString( response.data, 'text/html' );
            colc.append( dom.firstChild );
        } );
        request.open( 'GET', conf.ajaxUrl + '?action=habza_more_reviews&offset=' + parseInt( offset, 10 ) );
        request.send();
    }
    
    if ( agreeAll ) {
        agreeAll.addEventListener( 'change', function ( e ) {
            var fields = this.dataset.fields.split( ',' ),
                form = this.closest( 'form' ),
                checked = this.checked;

            fields.forEach( function ( elem ) {
                form[ elem ].checked = checked;
            });
        });
    }
}( window.HabzaReviewsConfig ));

// Review – add new
(function ( conf ) {
    var form = document.forms['review-form'],
        button = form.elements.button;

    if ( ! form ) {
        return;
    }

    form.addEventListener( 'submit', function ( e ) {
        var request = new XMLHttpRequest(),
            data = new FormData( form );

        e.preventDefault();

        button.disabled = true;

        request.addEventListener( 'load', function () {
            var response = JSON.parse( request.response );

            if ( response.success ) {
                var msg = document.createElement( 'div' );
                msg.innerHTML = 'Twoja opinia została do nas przesłana i oczekuje na akceptację. Dziękujemy.';
                form.parentNode.append( msg );
                form.remove();
            }
        });
        request.open( 'POST', conf.ajaxUrl );
        request.send( data );
    });
}( window.HabzaReviewsConfig ));

// Filter
(function ( conf ) {
    var filters = document.querySelector( '.filters' );

    if ( ! filters ) {
        return;
    }

    filters.addEventListener( 'change', function ( e ) {
        //
    });
}( window.HabzaReviewsConfig ));

// Back to top button
(function () {
    var btn = document.querySelector( '.back-to-top' ),
        header = document.querySelector( '.site-header' ),
        observer;

    if ( ! btn || 1023 < window.innerWidth ) {
        return;
    }

    function toggleBtn( entries ) {
        entries.forEach( function ( entry ) {
            if ( entry.isIntersecting ) {
                btn.style.display = 'none';
            } else {
                btn.style.display = 'block';
            }
        });
    }

    observer = new IntersectionObserver( toggleBtn, {
        rootMargin: '200px'
    });
    observer.observe( header );

    btn.addEventListener( 'click', function ( e ) {
        e.preventDefault();
        window.scrollTo(0,0);
    });
}());